import { render, staticRenderFns } from "./TagsSub.vue?vue&type=template&id=c266a4e4&scoped=true&"
import script from "./TagsSub.vue?vue&type=script&lang=js&"
export * from "./TagsSub.vue?vue&type=script&lang=js&"
import style0 from "./TagsSub.vue?vue&type=style&index=0&id=c266a4e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c266a4e4",
  null
  
)

export default component.exports